/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/itemgrideditor.ts" />
namespace TabAurous.Inventory {

    import fld = StockAllocatedItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class StockAllocatedItemsEditor extends _Ext.GridEditorBase<StockAllocatedItemsRow> {
        protected getColumnsKey() { return "Inventory.StockAllocatedItems"; }
        protected getDialogType() { return StockAllocatedItemsDialog; }
        protected getLocalTextPrefix() { return StockAllocatedItemsRow.localTextPrefix; }
        protected form: StockAllocatedItemsForm;

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        private pendingChanges: Q.Dictionary<any> = {};

        public PartyId: number = 0;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        private GenSKU: boolean = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        isEditable: boolean;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: false, rowHeight: 30 });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');
             
            Q.reloadLookup(OMS.DepartmentMasterRow.lookupKey);
            var value = q.ToBool(TabAurous.GetConfigValue(1004));
            if (value == true)
                this.GenSKU = true;
            else
                this.GenSKU = false;

            this.isEditable = this.slickGrid.getOptions().editable;



        }
        protected getColumns() {

            var columns = super.getColumns();

            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }


        public Editable() {
            this.isEditable = true;
        }


        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            let CurrentStock: Stock.StockItemRow;


            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                AttributeId: item.AttributeId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );
            if (field === fld.Pieces && value > 0) {
                if (value > CurrentStock.Pieces) {
                    q.Alert('Invalid Entry', 'Entered pieces are more than available stock', 2500, false);
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                item.Weight = (CurrentStock.Weight / CurrentStock.Pieces) * value;
                item.DiamondPieces = (CurrentStock.DiamondPieces / CurrentStock.Pieces) * value;
                item.DiamondWeight = (CurrentStock.DiamondWeight / CurrentStock.Pieces) * value;
                item.StonePieces = (CurrentStock.StonePieces / CurrentStock.Pieces) * value;
                item.StoneWeight = (CurrentStock.StoneWeight / CurrentStock.Pieces) * value;
                item.OtherPieces = (CurrentStock.OtherPieces / CurrentStock.Pieces) * value;
                item.OtherWeight = (CurrentStock.OtherWeight / CurrentStock.Pieces) * value;
                item.NetWeight = (CurrentStock.NetWeight / CurrentStock.Pieces) * value;
                item.BOMDetails.forEach(function (x) {
                    var Pieces = (x.Pieces / item.Pieces) * value;
                    var Weight = (x.Weight / item.Pieces) * value;
                    if (x.CalcOnId == 3) {
                        x.BomAmount = x.BomRate * Pieces;
                    }
                    else {
                        if (x.ItemTypeId == 104)
                            x.BomAmount = x.BomRate * Weight * x.Purity;
                        else
                            x.BomAmount = x.BomRate * Weight;
                    }
                    x.Pieces = Pieces;
                    x.Weight = Weight;
                })
                item[field] = value;

            }
            if (field === fld.Weight && value > 0) {
                if (value > CurrentStock.Weight) {
                    q.Alert('Invalid Entry', 'Entered weight is more than available stock', 1000, false);
                    item[field] = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                item[field] = value;
            }


            this.view.updateItem(id, item);

            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            //**** Master ****//

            //**** POS Order ****//
            buttons.push({
                title: "Select POSOrders",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    var grid = Retail.POSOrderItemsSelectGrid;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;
                    }
                    else {

                        var filters: _Ext.SelectGridFilters = {
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetLocationTransferItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);
                    }

                    pickerDialog.dialogOpen();
                }
            });



            //**** Sales Order ****//
            buttons.push({
                title: "Select SO",
                cssClass: "order-button",
                hotkey: "alt+i",
                hint: 'alt+i',
                onClick: () => {
                    var grid = SalesOrder.OrderItemsForPurchaseGrid;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetLocationTransferItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);

                    }
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        setData(ItemDetails: any[]) {

            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

    }
}